import React from 'react';

import { BrowserRouter as Router } from 'react-router-dom';

import 'react-datepicker/dist/react-datepicker.css';
import GlobalStyles from './styles/global';

import { AuthProvider } from './hooks/AuthContext';

import Routes from './routes';
import Loader from './components/Loader';

const App: React.FC = () => {
  return (
    <Router>
      <Loader />
      <AuthProvider>
        <Routes />
      </AuthProvider>

      <GlobalStyles />
    </Router>
  );
};

export default App;
